import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button,
  Box,
  Grid,
  Typography
} from '@material-ui/core';
import { SkeletonCardFields } from 'components/Loading';
import { QueryBuilder } from 'components';
import { constants } from 'views/Campaign';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  button: {
    margin: theme.spacing(1)
  },
  deleteButton: {
    color: theme.palette.error.main
  },
  containerMargin: {
    marginLeft: theme.spacing(3)
  },
  containerAndMargin: {
    marginLeft: theme.spacing(3),
    textAlign: 'left',
    fontWeight: 'bold'
  },
  selectContainer: {
    display: 'inline',
    minWidth: '14rem',
    margin: theme.spacing(1)
  },
  buttonContainer: {
    display: 'inline',
    margin: theme.spacing(1)
  },
  ruleError: {
    color: theme.palette.error.main,
    paddingTop: '13px'
  },
  dateField: {
    width: '100%',
    marginTop: '0px'
  },
  templateButtonError: {
    paddingLeft: '19px',
    color: theme.palette.error.main
  },
  ruleDivider: {
    marginTop: '10px',
    marginBottom: '10px'
  }
}));

const ExclusionRules = props => {
  const { className, campaign, next, back, showNav, ...rest } = props;
  const {
    thisCampaign,
    handleChange,
    attributes,
    goNext,
    goBack,
    isLoading,
    shouldShowError,
    getErrorMessage,
    isCampaignReadOnly
  } = campaign;

  const { INTERNAL_SURVEY_RESPONSE, EXTERNAL_SURVEY_RESPONSE } = constants.campaignOccurrenceTypes;

  const classes = useStyles();

  if (thisCampaign.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE || thisCampaign.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE)
    return null;


  const SkeletonCardContent = props => {
    return (
      <CardContent>
        <Grid container spacing={0}>
          <SkeletonCardFields />
        </Grid>
      </CardContent>
    );
  };

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <CardHeader
            subheader=""
            title="Exclusion Rules"
            titleTypographyProps={{ variant: 'h1' }}
          />
          <Divider />
          {isLoading && <SkeletonCardContent />}
          {!isLoading && (!thisCampaign.uuid || thisCampaign._hasSetCampaignExclusionRules) && (
            <CardContent>
              {(!thisCampaign.campaignExclusionConditionExpression?.subConditionExpressions?.length > 0 && isCampaignReadOnly())
                ? 'There are no exclusion rules in this campaign.'
                : (<React.Fragment>
                  {(campaign.thisCampaign.hasMovedToNextStep || campaign.thisCampaign.uuid) && <QueryBuilder
                    name="campaignExclusionConditionExpression"
                    isLoading={isLoading}
                    query={{ ...thisCampaign?.campaignExclusionConditionExpression } || {}}
                    template={{ thisTemplate: thisCampaign, attributes, templateId: thisCampaign?.campaignExclusionConditionExpression?.id }}
                    onChange={handleChange}
                    isReadOnly={isCampaignReadOnly}
                  />}
                  {(shouldShowError(`campaignExclusionConditionExpression.subConditionExpressions`) ||
                    shouldShowError(`campaignExclusionConditionExpression.valid`)) && (
                      <Typography
                        className={classes.templateButtonError}
                        variant="caption"
                        display="block">
                        *Please enter a complete valid expression.
                      </Typography>
                    )}
                </React.Fragment>
                )}
            </CardContent>
          )}
          {(next || back || showNav) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button
                  color="secondary"
                  variant="contained"
                  linkTo={back}
                  onClick={goBack}>
                  Back
                </Button>
                <Box flexGrow={1}>&nbsp;</Box>
                <Button
                  color="primary"
                  variant="contained"
                  linkTo={next}
                  onClick={goNext}>
                  Next
                </Button>
              </CardActions>
            </>
          )}
        </form>
      </Card>
    </div>
  );
};

export default ExclusionRules;
